import React, { useState } from "react";
import { Nav, Navbar, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import royalgreenlogo from "../../Assets/royalgreenlogo.webp";
import "./header.module.css";
import "../../App.css";
import GoogleTranslate from "../GoogleTranslate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { useCart } from "../../Contexts/CartContext";
import CartModal from "../CartModal";

function Header() {
  const { cartItems } = useCart();
  const [isCartVisible, setIsCartVisible] = useState(false);

  const handleCartClick = () => {
    setIsCartVisible(true);
  };

  const handleCartClose = () => {
    setIsCartVisible(false);
  };

  const totalQuantity = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <div className="navbar-container">
      <Navbar expand="xl" className="navbar-light sticky-top">
        <Container fluid className="px-4">
          <Navbar.Brand href="#home" className="text-dark">
            <img src={royalgreenlogo} width="150" alt="Royal Green Logo" />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="text-dark"
          />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end"
          >
            <Nav>
              <Nav.Link
                as={Link}
                to="/"
                className="text-uppercase text-center mx-1 fw-bold bg-transparent"
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/about"
                className="text-uppercase text-center mx-1 fw-bold bg-transparent"
              >
                About Us
              </Nav.Link>
              {/* <NavDropdown
                title="Company"
                id="company-nav-dropdown"
                className="text-uppercase text-center mx-1 fw-bold bg-transparent"
              >
                <NavDropdown.Item as={Link} to="/about">
                  About Us
                </NavDropdown.Item>
                 <NavDropdown.Item as={Link} to="/customerReview">
                  Customer Review
                </NavDropdown.Item> 
              </NavDropdown> */}

              {/* <NavDropdown
                title="Projects"
                id="projects-nav-dropdown"
                className="text-uppercase text-center mx-1 fw-bold bg-transparent"
              >
                <NavDropdown.Item as={Link} to="/gallery">
                  Gallery
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/videos">
                  Videos
                </NavDropdown.Item>
              </NavDropdown> */}

              <NavDropdown
                title="Products"
                id="Automation_products"
                className="text-uppercase text-center mx-1 fw-bold bg-transparent"
              >
                {/* <NavDropdown.Item as={Link} to="/Automation_Products_Pens">
                  Pole Fittings & Accessories
                </NavDropdown.Item> */}
                <NavDropdown.Item
                  as={Link}
                  to="/Insulator_fittings_and_accessories"
                >
                  Insulator Fittings & Accessories
                </NavDropdown.Item>
                {/* <NavDropdown.Item as={Link} to="/Automation_Products_Meters">
                  Anchoring Equipments
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/Automation_Products_Testing_and_Maintenance"
                >
                  Conductor Fittings & Accessories
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item as={Link} to="/Greenhouse_Accessories">
                  Fasteners
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Hydroponics-systems-shop">
                  Telecommunication Accessories
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item as={Link} to="/Hydroponics-systems-shop">
                  Aerial Bunched Cable Fittings & Accessories
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Hydroponics-systems-shop">
                  ABC Accessories
                </NavDropdown.Item> */}
                <NavDropdown.Item
                  as={Link}
                  to="/Electric_fittings_and_components"
                >
                  Electric Fittings & Components
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Tension_clamp">
                  Tension Clamp
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Cross_arm">
                  Cross Arm
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/SPDC_PAN"> 
                  SPDC PAN
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                as={Link}
                to="/Blog"
                className="text-uppercase text-center mx-1 fw-bold bg-transparent"
              >
                Blog
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/contact"
                className="text-uppercase text-center mx-1 fw-bold bg-transparent"
              >
                Contact Us
              </Nav.Link>

              <a
                href="https://wa.me/+919960991166"
                target="_blank"
                className="text-center mx-1 fw-bold"
              >
                <i className="fa-brands fa-whatsapp fs-1 mx-1 text-green rotate"></i>
              </a>

              <NavDropdown
                title="Select Language"
                className="text-uppercase text-center mx-1 fw-bold bg-transparent"
              >
                <div className="px-3 py-2">
                  <GoogleTranslate />
                </div>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Cart Modal */}
      {isCartVisible && <CartModal onClose={handleCartClose} />}
    </div>
  );
}

export default Header;
